<template>
  <section class="header-submenu">
    <div class="header-submenu__panel">
      <div class="header-submenu__panel__option" :class="idAssetSelected == 1 ? 'active' : ''" @click="selected(1)">
        Resumen
      </div>
      <div class="header-submenu__panel__option" :class="idAssetSelected == 3 ? 'active' : ''" @click="selected(3)">
        Distribución
      </div>
      <div class="header-submenu__panel__option" :class="idAssetSelected == 7 ? 'active' : ''" @click="selected(7)">
        Tendencia LIVE
      </div>
      <div class="header-submenu__panel__option" :class="idAssetSelected == 9 ? 'active' : ''" @click="selected(9)">
        Goles esperados (xG)
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { ItemNextMatchesSelect } from '@/utils/analytics';
export default {
  name: 'HeaderSubMenu',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getIsGolstats']),
    ...mapGetters('general', ['getPreviewSectionAnalytics']),
    ...mapGetters('nextGeneral', ['idAssetSelected']),
  },
  watch: {},
  methods: {
    ...mapMutations('nextGeneral', ['updateIdAssetSelected']),
    ...mapGetters('nextGeneral', ['isLive', 'gameId']),
    ...mapMutations('general', ['setSectionAnalytics']),
    ...mapMutations(['SET_PREMIUM_MESSAGE_V2']),
    selected(id) {
      let stringComponentSelected = '';
      if (id === 1) {
        stringComponentSelected = 'resumen';
      }
      if (id === 3) {
        stringComponentSelected = 'distribution';
      }
      if (id === 7) {
        stringComponentSelected = 'tendencialive';
      }
      if (id === 9) {
        stringComponentSelected = 'xg';
      }
      ItemNextMatchesSelect(
        stringComponentSelected,
        this.getPremiumAccount,
        this.isLive(),
        this.gameId(),
        this.getPreviewSectionAnalytics,
        this.getIsGolstats,
      );
      if (![7, 9].includes(id) || this.getPremiumAccount) {
        this.updateIdAssetSelected(id);
      } else {
        // console.log('no premium vallor');
        // this.setSectionAnalytics(this.item.banner);
        this.SET_PREMIUM_MESSAGE_V2(true);
      }
    },
  },

  async created() {},
};
</script>

<style lang="scss" scoped>
.active {
  border: solid 2px #132739;
  line-height: 14px !important;
  @media screen and (max-width: 540px) {
    line-height: 4px !important;
  }
}
.header-submenu {
  width: 100%;
  height: 33px;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 706px) {
    height: 40px;
    display: inline-flex;
    justify-content: left;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  @media screen and (max-width: 540px) {
    height: 33px;
  }
  &__panel {
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 33px;
    @media screen and (max-width: 706px) {
      height: 40px;
      display: inline-flex;
      justify-content: left;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
    }
    @media screen and (max-width: 540px) {
      height: 33px;
    }
    &__option {
      width: auto;
      height: 33px;
      padding: 8px 24px;
      font-family: 'Avenir-Demi';
      border-radius: 25px;
      margin-left: 8px;
      margin-right: 8px;
      background-color: rgba(203, 238, 109, 0.5);
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 17px;
      letter-spacing: -0.16px;
      text-align: center;
      color: #132739;
      white-space: nowrap;

      @media screen and (max-width: 640px) {
        margin-left: 4px;
        margin-right: 4px;
        font-size: 14px;
      }
      @media screen and (max-width: 540px) {
        height: 25px;
        font-size: 12px;
        line-height: 8px;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  ::-webkit-scrollbar {
    height: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    //box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */

  ::-webkit-scrollbar-thumb {
    background: #e5e7ec;
    border-radius: 10px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #e5e7ec;
  }
}
</style>
